module.exports = __webpack_public_path__ + "assets/icon-fav-star-selected.06188281.svg";